<template>
  <div class="c-modal-user-role">
    <b-modal
      @hidden="$emit('close')"
      size="sm"
      title="ارتقا به ادمین"
      :hide-footer="true"
      :id="id">

      <div>
        <label for="">
          انتخاب نقش مدیر
        </label>
        <b-form-select
          v-model="adminRole"
          :options="options"/>

        <base-button
          @click="updateAdminRole"
          :loading="loading"
          type="success" class="mt-4">
          ذخیره
        </base-button>

      </div>

    </b-modal>
  </div>
</template>

<script>

import Swal from "sweetalert2";
import _ from "lodash";
import store from '@/store'
import {updateUserRole} from "@/httpservices/User";

export default {

  name: "ModalChangeUserRole",

  props: {
    role: {
      type: String,
      default: "",
    }
  },

  data() {
    return {
      adminRole: "",
      loading: false,
      id: 'modal-change-user-role',
      options: [
        {value: 'SuperAdmin', text: 'سوپرادمین'},
        {value: 'ManagerAdmin', text: 'ادمین'},
        {value: 'ApprovingManager', text: 'ادمین احراز هویت'},
        {value: 'Operator', text: 'کارشناس'},
        {value: 'Trader', text: 'کاربر معمولی'},
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.adminRole = this.role;
      this.$bvModal.show(this.id);
    });
  },

  methods: {
    async updateAdminRole() {
      this.loading = true;
      try {
        await updateUserRole(this.$route.params.id, this.adminRole);
        await Swal.fire({
          icon: 'success',
          title: 'با موفقیت انجام شد.',
        })
        this.$emit('close');
        this.$emit('onUpdate');
      } catch (e) {
        console.log(e)
      }
      this.loading = false;
    }
  },

}
</script>

<style scoped>

</style>
